import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download } from "lucide-react";
import { cardCls, fmtDateTime } from "./ui";

export const DocumentsSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/documents").then((r) => setItems(r.data.items)).catch(() => {});
  }, []);

  return (
    <div className={cardCls} data-testid="admin-documents-section">
      {items.length === 0 && <p className="px-5 py-10 text-sm text-midnight/40">No uploaded documents yet. Files attached to RFQs appear here.</p>}
      {items.map((d) => (
        <div key={d.id} className="flex flex-wrap items-center gap-x-6 gap-y-1 px-5 py-4 border-b border-midnight/[0.06]">
          <span className="font-mono text-xs text-gold font-medium">{d.reference}</span>
          <span className="text-sm text-midnight font-medium">{d.company_name}</span>
          <span className="text-xs text-midnight/50">{d.file_name}</span>
          <span className="text-xs text-midnight/40">{fmtDateTime(d.created_at)}</span>
          <a href={`${api.defaults.baseURL}/admin/rfqs/${d.id}/file`} data-testid={`doc-download-${d.reference}`} className="ml-auto flex items-center gap-2 text-xs font-medium text-midnight hover:text-gold transition-colors">
            <Download size={13} /> Download
          </a>
        </div>
      ))}
    </div>
  );
};
